import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import {
  CustomProffixService, HelpersService, UserSessionService,
  LocalStorageService, UserDefaults, AbwesenheitsAntrag, AbwesenheitsAntragStunden
} from '../../services';

import {
  Login,
  Mitarbeiter,
  MitarbeiterService,
  StundenService,
  Stunden,
  StundenartService,
  Stundenart
} from '@proffix/restapi-angular-library';

@Component({
  selector: 'app-absences',
  templateUrl: './absences.component.html',
  styleUrls: ['./absences.component.css']
})
export class AbsencesComponent implements OnInit {
  proffixLogin: Login = null;

  private _page = 1;
  itemsPerPage = 10;
  isLoaded = false;
  isManager = false;
  isTeamleiter = false;

  filterMitarbeiterNr = 0;
  filterStatusCode = '0';
  filterStundenart = '-';
  filterPeriode = '-';

  userDefaults: UserDefaults;

  listOfAbwesenheitsAntraege: AbwesenheitsAntrag[];
  listOfCurrentAntragsStunden: AbwesenheitsAntragStunden[];
  listOfMitarbeiter: Mitarbeiter[];
  listOfStundenarten: Stundenart[];
  listOfPerioden: string[] = [];

  constructor(
    private _customProffixService: CustomProffixService,
    private _helpersService: HelpersService,
    private _userSessionService: UserSessionService,
    private _localStorageService: LocalStorageService,
    private _mitarbeiterService: MitarbeiterService,
    private _stundenService: StundenService,
    private _stundenartService: StundenartService,
    private _modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this._userSessionService.getProffixLogin().subscribe(data => {
      this.proffixLogin = data;
      this.isManager = this._userSessionService.isManager();
      this.isTeamleiter = this._userSessionService.isTeamleiter();
      this.userDefaults = this._localStorageService.loadUserDefaults(data.Benutzer);

      if (data) {
        if (this.isManager === false && this.isTeamleiter === false) {
          this.filterMitarbeiterNr = data.Mitarbeiter.MitarbeiterNr;
        } else {
          this.filterMitarbeiterNr = this.userDefaults.FilterMitarbeiterNr ? this.userDefaults.FilterMitarbeiterNr : 0;
        }

        if (this.userDefaults) {
          this.filterStatusCode = this.userDefaults.FilterStatusCode ? this.userDefaults.FilterStatusCode : '0';
          this.filterStundenart = this.userDefaults.FilterStundenart ? this.userDefaults.FilterStundenart : '-';
          this.filterPeriode = this.userDefaults.FilterPeriode ? this.userDefaults.FilterPeriode : '-';
          this.itemsPerPage = this.userDefaults.ItemsPerPage ? this.userDefaults.ItemsPerPage : 10;
        }

        // load the list of all Mitarbeiter that the current user is allowed to see
        this._customProffixService
          .getListOfAssignedMitarbeiter(this.proffixLogin.Mitarbeiter.MitarbeiterNr, this.isManager)
          .subscribe(result => {
            this.listOfMitarbeiter = this.SortMitarbeiterByName(result);

            this.loadAbwesenheitsAntraege();
            this.loadStundenarten();
          });


        this.listOfPerioden = this._helpersService.getListOfPeriodes(new Date(), 3, 12);
      }
    });
  }

  get page(): number {
    // transform value for display
    return this._page;
  }

  @Input()
  set page(value: number) {
    if (value > 0) {
      this._page = value;
      this.loadAbwesenheitsAntraege();
    }
  }

  public changeItemsPerPage() {
    this.search();
  }

  public pageBack() {
    if (this.page > 1) {
      this.page = this.page - 1;
    }
  }

  public pageNext() {
    this.page = this.page + 1;
  }

  public search() {
    this._page = 1;
    this.loadAbwesenheitsAntraege();

    // store the search form values
    this.userDefaults.FilterMitarbeiterNr = this.filterMitarbeiterNr;
    this.userDefaults.FilterStatusCode = this.filterStatusCode;
    this.userDefaults.FilterStundenart = this.filterStundenart;
    this.userDefaults.FilterPeriode = this.filterPeriode;
    this.userDefaults.ItemsPerPage = this.itemsPerPage;

    this._localStorageService.saveUserDefaults(this.proffixLogin.Benutzer, this.userDefaults);
  }

  public filterVerwendeteStundenarten(s: Stundenart): boolean {
    return s.Zusatzfelder.Z_In_Zeitmanagement_WebApp_verwenden === true;
  }

  private loadAbwesenheitsAntraege() {
    this.isLoaded = false;

    this._userSessionService.handleRequest(() => {
      return this._customProffixService.getAbwesenheitsAntraege(
        {
          sort: '-StartDatum',
          limit: this.itemsPerPage,
          offset: this.getOffset(),
          filter: this.getFilterString(),
        });
    }).subscribe((result) => {
      this.listOfAbwesenheitsAntraege = result;
      this.isLoaded = true;
    });
  }

  private SortMitarbeiterByName(listOfMitarbeiter: Mitarbeiter[]): Mitarbeiter[] {
    listOfMitarbeiter.sort((x, y) => {
      if (x.Adresse.Name < y.Adresse.Name) {
        return -1;
      } else if (x.Adresse.Name > y.Adresse.Name) {
        return 1;
      } else {
        return 0;
      }
    });

    return listOfMitarbeiter;
  }

  private getFilterString(): string {
    let filter = '';

    if (this.filterMitarbeiterNr !== 0) {
      filter = filter + 'MitNrPRO==' + this.filterMitarbeiterNr + ',';
    } else {
      // filter for all employees the current role is assigned to see
      filter = filter + '(';
      this.listOfMitarbeiter.forEach(m => {
        filter = filter + 'MitNrPRO==' + m.MitarbeiterNr + '|';
      });
      filter = filter.slice(0, -1);
      filter = filter + '),';
    }

    if (this.filterStatusCode !== '0') {
      filter = filter + 'StatusCode==' + this.filterStatusCode + ',';
    }

    if (this.filterStundenart !== '-') {
      filter = filter + 'StundenartZEI=="' + this.filterStundenart + '",';
    }

    if (this.filterPeriode && this.filterPeriode.length === 6) {
      filter = filter + this._helpersService.getPeriodeFilterString('StartDatum', this.filterPeriode);
    }

    return filter.slice(0, -1);
  }

  private getOffset() {
    return (this.page - 1) * this.itemsPerPage;
  }

  private loadStundenarten() {
    this._stundenartService.getAll({}).subscribe(result => {
      result.sort((x, y) => {
        if (x.Bezeichnung < y.Bezeichnung) {
          return -1;
        } else if (x.Bezeichnung > y.Bezeichnung) {
          return 1;
        } else {
          return 0;
        }
      });

      this.listOfStundenarten = result.filter((s) => {
        if (s.ZeitErfassen === true) {
          return false;
        } else {
          // only use "Stundenarten" that do not have a start and an end time.
          return true;
        }
      });
    });
  }

  public getMitarbeiterName(mitNrPRO: number): string {
    if (this.listOfMitarbeiter !== undefined) {
      const ma = this.listOfMitarbeiter.find(x => x.MitarbeiterNr === mitNrPRO);

      if (ma !== undefined) {
        return ma.Adresse.Name + ' ' + ma.Adresse.Vorname;
      }
    }

    return '';
  }

  public getStundenartBezeichnung(stundenartNr: string): string {
    if (this.listOfStundenarten !== undefined) {
      const sa = this.listOfStundenarten.find(x => x.StundenartNr === stundenartNr);

      if (sa !== undefined) {
        return sa.Bezeichnung;
      }
    }

    return '';
  }

  public filterVisibleMitarbeiter(ma: Mitarbeiter): boolean {
    return ma && ma.Zusatzfelder && ma.Zusatzfelder.Z_Zeitmanagement_Rolle && ma.Zusatzfelder.Z_Zeitmanagement_Rolle !== '';
  }

  public updateBemerkungManager(antrag: AbwesenheitsAntrag) {
    this._userSessionService.handleRequest(() => {
      return this._customProffixService.putAbwesenheitsAntraege(antrag);
    }).subscribe(() => { });
  }

  public showAntragsStunden(antrag: AbwesenheitsAntrag, content: any) {
    this._customProffixService.getAbwesenheitsAntragStunden({
      filter: 'AbwAntragKopfId=="' + antrag.Id + '"',
    }).subscribe((listOfAntragsStunden) => {
      this.listOfCurrentAntragsStunden = listOfAntragsStunden;

      this._modalService.open(content);
    });
  }

  public acceptAbwesenheitsAntrag(antrag: AbwesenheitsAntrag) {
    const listOfStunden: Stunden[] = [];

    // set the status of the "Antrag" to "Accepted"
    antrag.StatusCode = 10;

    this._customProffixService.getAbwesenheitsAntragStunden({
      filter: 'AbwAntragKopfId=="' + antrag.Id + '"',
    }).subscribe((listOfAntragsStunden) => {
      listOfAntragsStunden = listOfAntragsStunden.filter((std) => {
        return std.Stunden > 0;
      });

      // update the "Antrag"
      this._customProffixService.putAbwesenheitsAntraege(antrag).subscribe(() => {
        // Create a request sequence and execute all requests
        this.postNextStunden(antrag, listOfAntragsStunden);
      });
    });
  }

  private postNextStunden(antrag: AbwesenheitsAntrag, listOfAntragsStunden: AbwesenheitsAntragStunden[]) {
    const antragsStunden = listOfAntragsStunden.shift();

    // It's a request for adding some hours (Stunden)
    const stunden: Stunden = {
      Mitarbeiter: { MitarbeiterNr: antrag.MitNrPRO },
      Stundenart: { StundenartNr: antrag.StundenartZEI },
      Datum: antragsStunden.Datum,
      StartZeit: '',
      EndZeit: '',
      Stunden: antragsStunden.Stunden,
      Pause: 0,
      Bemerkungen: antrag.BemerkungMitarbeiter,
      Quelle: 'TimeManagement Web',
      QuelleStop: 'TimeManagement Web',
    };

    this._customProffixService.postStunden(stunden).subscribe(() => {
      if (listOfAntragsStunden.length > 0) {
        this.postNextStunden(antrag, listOfAntragsStunden);
      } else {
        // reload the "Anträge"
        this.loadAbwesenheitsAntraege();
      }
    });
  }

  public changeStatusOfStundenantrag(antrag: AbwesenheitsAntrag, newStatusCode: number) {
    // set the given code ans save the Antrag
    antrag.StatusCode = newStatusCode;

    this._userSessionService.handleRequest(() => {
      return this._customProffixService.putAbwesenheitsAntraege(antrag);
    }).subscribe(() => { });
  }

  public calculateTimeSpan(timeFrom: string, timeTo: string): number {
    return this._helpersService.calculateTimeSpan(timeFrom, timeTo);
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/absences/absences.component.ts